import { useMemo, useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import "react-datepicker/dist/react-datepicker.css";
import { LuCalendarRange, LuClock3 } from "react-icons/lu";
import moment from "moment-timezone";
import FormFieldLayout from "../FormField/FormFieldLayout";
import CustomDatePicker from "../CustomDatePicker";
import PropTypes from 'prop-types';

const initial = new Date();
initial.setHours(0, 0, 0, 0);

const OptOutCaptureForm = ({
  timezone = "UTC",
  captureDate,
  setCaptureDate,
  captureTime,
  setCaptureTime,
  hasSubmitted,
}) => {
  const nowInTZ = useMemo(() => moment.tz(timezone), [timezone]);
  const isSameDate = useMemo(() => moment(captureDate).format("YYYY-MM-DD") ===
    nowInTZ.format("YYYY-MM-DD"), [captureDate,
    nowInTZ])

  const currentDateTimeStr = useMemo(
    () => nowInTZ.format("YYYY-MM-DD HH:mm"),
    [nowInTZ],
  );
  const maxCaptureDate = nowInTZ.toDate();

  const filterPassedTime = useCallback(
    (time, date) => {
      if (!(captureDate || date)) return true;
      if (!isSameDate) return true;
      if (nowInTZ.format("HH:mm:ss") > moment(time).format("HH:mm:ss"))
        return true;
      return false;
    },
    [captureDate, nowInTZ, isSameDate],
  );
  useEffect(() => {
    if (isSameDate && captureTime) {
      if (moment(captureTime).format("HH:mm:ss") > nowInTZ.format("HH:mm:ss"))
        setCaptureTime(null)
    }
  }, [isSameDate, captureTime, nowInTZ, setCaptureTime])


  return (
    <>
      <div className="row py-2">
        <div className="col-12">
          <p>
            <FormattedMessage
              id="label.current-date-time"
              defaultMessage="Current date and time in the time zone is {tzDateTime}"
              values={{ tzDateTime: currentDateTimeStr }}
            />
          </p>
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-sm-6">
          <FormFieldLayout label="Capture Date" value={captureDate?.toString()} rules={{ required: true, hasSubmitted, message: "Please select the capture date" }}>
            <CustomDatePicker
              selected={captureDate}
              onChange={setCaptureDate}
              dateFormat="yyyy-MM-dd"
              maxDate={maxCaptureDate}
              placeholderText="Select Capture Date"
              aria-label="Select Capture Date"
              showIcon
              icon={<LuCalendarRange />}
            />
          </FormFieldLayout>
        </div>
        <div className="col-sm-6">
          <FormFieldLayout label="Capture Time">
            <CustomDatePicker
              placeholderText="Select Capture Time"
              aria-label="Select Capture Time"
              showTimeSelect
              showTimeSelectOnly
              timeCaption="Time"
              dateFormat="h:mm aa"
              timeIntervals={1}
              openToDate={initial}
              showIcon
              icon={<LuClock3 />}
              filterTime={filterPassedTime}
              selected={captureTime}
              onChange={setCaptureTime}
            />
          </FormFieldLayout>
        </div>
      </div>
    </>
  );
};
OptOutCaptureForm.propTypes = {
  timezone: PropTypes.string,
  captureDate: PropTypes.instanceOf(Date),
  setCaptureDate: PropTypes.func.isRequired,
  captureTime: PropTypes.instanceOf(Date),
  setCaptureTime: PropTypes.func.isRequired,
  hasSubmitted: PropTypes.bool.isRequired,
};

export default OptOutCaptureForm;
